import { isEmpty, uniqBy, unionBy } from 'lodash-es';
import { getCoreUrl, getCustomCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { sortByYear } from 'site-modules/shared/utils/sorting';
import { PUB_STATES } from 'client/constants/pub-states';
import { getCurrentYear } from 'site-modules/shared/utils/time-util';

const MIN_YEAR_FOR_SALE = 2000;

export const isUsedModelYear = publicationStates =>
  publicationStates?.length === 1 && publicationStates.includes(PUB_STATES.USED);

export const getModelYears = modelYears =>
  modelYears.map(({ makeSlug, modelSlug, year }) => ({
    name: year,
    url: getCoreUrl({ makeSlug, modelSlug, year }),
  }));

export const getFilteredModelYears = (years, model) => {
  if (isEmpty(years)) {
    return [];
  }
  const identicalModelYears = uniqBy(
    years.filter(({ modelName }) => model === modelName),
    'year'
  );
  const lowestPricedModelYears = uniqBy(years, 'year');
  return unionBy(identicalModelYears, lowestPricedModelYears, 'year').sort(sortByYear);
};

export const getModelYearsWithReview = (years, defaultYear) => {
  const recentUsedYear = years.find(
    ({ year, publicationStates }) => parseInt(year, 10) === getCurrentYear() - 2 && isUsedModelYear(publicationStates)
  )?.year;

  return years.map(({ makeSlug, modelSlug, year, publicationStates }) => {
    const isUsed = isUsedModelYear(publicationStates);

    return {
      name: year,
      url: getCoreUrl({ makeSlug, modelSlug, year, defaultYear }, isUsed),
      noFollow: year !== recentUsedYear && isUsed,
    };
  });
};

export const getModelYearsForSale = modelYears =>
  getModelYears(
    modelYears.filter(
      ({ publicationStates, year }) => publicationStates.includes(PUB_STATES.USED) && year >= MIN_YEAR_FOR_SALE
    )
  );

export const getForSaleLinks = ({ forSaleYears, makeSlug, modelSlug }) =>
  forSaleYears
    ? forSaleYears.map(year => ({
        name: year.toString(),
        url: getCustomCoreUrl({ makeSlug, modelSlug, year }, 'for-sale/'),
      }))
    : [];
